export default __webpack_public_path__ + "static/media/emily_real_1.affffd0c.wav";